/**
 * Check is currently on search page
 *
 * @returns {boolean} true/false
 */
const checkIsSearchPage = () => {
  if (window.location.pathname.includes('search')) {
    return true;
  }
  return false;
};
/**
 * Check is currently on product page
 *
 * @returns {boolean} true/false
 */
const checkIsProductPage = () => {
  if (window.location.pathname.includes('products')) {
    return true;
  }
  return false;
};
/**
 * Check if serach terms in url exist
 *
 * @returns {boolean} true/false
 */
const checkIsSearchTermsExist = () => {
  if (window.location.search !== '' && window.location.search !== '?q=' && window.location.search.length > 3) {
    return true;
  }
  return false;
};
/**
 * Update local storage
 */
const updateStorageState = () => {
  if (!checkIsProductPage() && !checkIsSearchPage() && !checkIsSearchTermsExist() && localStorage.getItem('searchData') !== null) {
    localStorage.removeItem('searchData');
  } else if ((checkIsSearchPage() || checkIsProductPage()) && !checkIsSearchTermsExist() && localStorage.getItem('searchData') !== null) {
    localStorage.removeItem('searchData');
  }
};

/**
 * Init load data on search page abd save in storage
 */
globalThis.initDataOnSearchPage = () => {
  if (checkIsSearchPage()) {
    const currentPage = document.querySelector('[data-current-page]')?.getAttribute('data-current-page');
    const products = document.querySelectorAll('.product-item');

    const storageData = {
      isComeFromSearchPage: true,
      pagesLoadedOnSearchPage: currentPage || 1,
    };
    if (products.length > 0 && storageData.pagesLoadedOnSearchPage > 1) {
      products.forEach((product) => {
        product.addEventListener('click', (e) => {
          if (e.target.nodeName === 'A') {
            localStorage.setItem('searchData', JSON.stringify(storageData));
          }
        });
      });
    }
  }
};

document.addEventListener('DOMContentLoaded', () => {
  if (checkIsSearchPage()) {
    window.history.scrollRestoration = 'manual';
  }
  updateStorageState();
  globalThis.initDataOnSearchPage();
});
